import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';

export default {
  name: 'modifyReading',
  components: {
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default
  },
  props: ['dataObj'],
  data: function () {
    return {
      appId: -1,
      appData: {
        clockOver: false,
        diffFromMain: 0,
        diffFromMainReadOnly: true,
        diffFromMainVisible: false,
        forcedConsumption: 0,
        forcedConsumptionChecked: false,
        forcedConsumptionReadOnly: true,
        forcedConsumptionVisible: false,
        isInvoiced: null,
        meterId: 0,
        reading: 0,
        readingDate: null,
        readingNumber: 0,
        readingReason: '',
        readingTime: ''
      },
      readingDateView: null,
      readOnly: false,
      lang: '',

      options: { pageSize: 10, total: 0, page: 1 },
      totalRow: 0,
      readingsCols: [],
      readings: [],
      noDataFound: false,
      keyColumn: 'readingNumber'
    }
  },
  created() {
    this.$material.locale.dateFormat = 'dd/MM/yyyy';
    this.$root.$on('modify_reading_updated', this.init);
    this.fillReadingsCol();
    this.init();
  },
  watch: {
    readingDateView: function (val) {
      this.appData.readingDate = moment(val, "DD/MM/YYYY").add(1, 'days');
    },
    "this.appData.clockOver": function () {
      this.updateConsumption();
    }
  },
  methods: {
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.appData = this.dataObj.appData;
        this.readOnly = this.dataObj.readOnly;
        this.readingDateView = this.$options.filters.formatDateDDMMYYY(this.appData.readingDate);
        console.log(this.appData);

        this.getReadings();
      });
    },
    getReadings() {
      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Options: this.options
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/ModifyReadingActivity/GetReadings', parameter),
        response => {
          if (response.status == 200)
            if (response.data.items.length == 0) {
              this.readings = [];
              this.noDataFound = true;
            }
            else {
              this.readings = response.data.items;
              this.options.total = response.data.itemsCount;
              this.totalRow = response.data.itemsCount;
            }
          this.$root.$emit('datagrid_updated');
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/ModifyReadingActivity/GetReadings', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log(response.data);
            
      //      if (response.data.items.length == 0) {
      //        this.readings = [];
      //        this.noDataFound = true;
      //      }
      //      else {
      //        this.readings = response.data.items;
      //        this.options.total = response.data.itemsCount;
      //        this.totalRow = response.data.itemsCount;
      //      }
      //      this.$root.$emit('datagrid_updated');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    updateConsumption() {
      var data = {
        meterId: this.appData.meterId,
        connectionId: this.appData.connectionId,
        readingNumber: this.appData.readingNumber,
        readingReason: this.appData.readingReason,
        readingDate: this.appData.readingDate,
        readingTime: this.appData.readingTime,
        reading: this.appData.reading,
        forcedConsumption: this.appData.forcedConsumption,
        forcedConsumptionChecked: this.appData.forcedConsumptionChecked,
        diffFromMain: this.appData.diffFromMain,
        clockOver: this.appData.clockOver,
        isInvoiced: this.appData.isInvoiced
      };

      var parameter = {
        ApplicationId: this.appId,
        ApplicationKey: 0,
        Item: JSON.parse(JSON.stringify(data))
      };

      this.$store.state.notifier.asyncBlock(
        axios.post('/ModifyReadingActivity/UpdateConsumption', parameter),
        response => {
          if (response.status == 200)
            this.$root.$emit('read_data_updated');
        },
        err => err.data == undefined ? this.$alertMsg(`${this.$t('messages.apiRespondedWithCode')} ${err.response.status}`) :
          this.$alertMsg(err.data.data.text)
      );

      //let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
      //axios.post('/ModifyReadingActivity/UpdateConsumption', parameter)
      //  .then(response => {
      //    if (response.status == 200) {
      //      console.log(response.data);
      //      this.$root.$emit('read_data_updated');
      //    }
      //    else {
      //      this.$alertMsg(response.data.data.text);
      //    }
      //    loader.hide();
      //  })
      //  .catch(error => {
      //    loader.hide();
      //    this.$alertMsg(error.response.data);
      //  });
    },
    //modifyReading() {
    //  var data = {
    //    meterId: this.appData.meterId,
    //    readingNumber: this.appData.readingNumber,
    //    readingReason: this.appData.readingReason,
    //    readingDate: moment(this.readingDate2, "DD/MM/YYYY").add(1, 'days'),
    //    readingTime: this.appData.readingTime,
    //    reading: this.appData.reading,
    //    forcedConsumption: this.appData.forcedConsumption,
    //    forcedConsumptionChecked: this.appData.forcedConsumptionChecked,
    //    diffFromMain: this.appData.diffFromMain,
    //    clockOver: this.appData.clockOver,
    //    isInvoiced: this.appData.isInvoiced
    //  };

    //  var parameter = {
    //    ApplicationId: this.appId,
    //    ApplicationKey: 0,
    //    Item: JSON.parse(JSON.stringify(data))
    //  };

    //  let loader = this.$loading.show({ color: '#23348d', loader: 'dots', width: 256, height: 256, backgroundColor: '#ffffff', opacity: 0.5 });
    //  axios.post('/ModifyReadingActivity/ModifyReading', parameter)
    //    .then(response => {
    //      if (response.status == 200) {
    //        console.log(response.data);
    //        this.$root.$emit('read_data_updated');
    //      }
    //      else {
    //        this.$alertMsg(response.data.data.text);
    //      }
    //      loader.hide();
    //    })
    //    .catch(error => {
    //      loader.hide();
    //      this.$alertMsg(error.response.data);
    //    });
    //},
    
    pageChange(pInfo) {
      this.options.page = pInfo.pageNumber;
      this.options.pageSize = pInfo.pageSize;
      this.getReadings();
    },
    fillReadingsCol() {
      this.readingsCols.push({ dataField: 'readingNumber', caption: this.$t('activities.readingNo') });
      this.readingsCols.push({ dataField: 'readingDate', caption: this.$t('activities.readingDate'), dataType: 'date', formatData: this.$options.filters.formatDateDDMMYYY });
      this.readingsCols.push({ dataField: 'readingTime', caption: this.$t('activities.readingTime') });
      this.readingsCols.push({ dataField: 'reading', caption: this.$t('activities.reading') });
      this.readingsCols.push({ dataField: 'clockOver', caption: this.$t('activities.clockOver'), dataType: 'boolean' });
      this.readingsCols.push({ dataField: 'isInvoiced', caption: this.$t('activities.billed'), dataType: 'boolean' });
    }
  },
}
